import React from "react";
import { Flavor, Persona, Platform } from "../../docs/loader";

export const TagBadge: React.FC<{ label: string }> = ({ label }) => (
  <span className="inline-flex items-center px-2 py-0.5 rounded-full text-xs bg-gray-100 dark:bg-gray-800 text-gray-700 dark:text-gray-200">
    {label}
  </span>
);

export const PlatformBadge: React.FC<{ platform: Platform }> = ({
  platform,
}) => (
  <span className="inline-flex items-center px-2 py-0.5 rounded-full text-xs bg-blue-100 dark:bg-blue-900/40 text-blue-800 dark:text-blue-200">
    {platform}
  </span>
);

export const FlavorBadge: React.FC<{ flavor: Flavor }> = ({ flavor }) => (
  <span className="inline-flex items-center px-2 py-0.5 rounded-full text-xs bg-purple-100 dark:bg-purple-900/40 text-purple-800 dark:text-purple-200">
    {flavor}
  </span>
);

export const PersonaBadge: React.FC<{ persona: Persona }> = ({ persona }) => (
  <span className="inline-flex items-center px-2 py-0.5 rounded-full text-xs bg-emerald-100 dark:bg-emerald-900/40 text-emerald-800 dark:text-emerald-200">
    {persona}
  </span>
);
